import React from 'react'
import { StyledCreateQuestionBox, StyledQuestionBoxHeader } from '../../../styles'
import { useDispatch } from 'react-redux'
import CreateQuestionCardDropDownMenu from './CreateQuestionCardDropDownMenu/index'
import { StyledBoxWrapper } from './styles'
import { blue, grey } from '../../../../../colors'
import { getEditableQuestion } from '../../../../../store/slices/SurveyTemplateSlice/selectors'
import { deleteQuestionFromSection, type ISurveySection, setBranchModal, setSelectedQuestion } from '../../../../../store/slices/SurveyTemplateSlice'
import GenericButton from '../../../../../components/GenericButton'
import { Box } from '@mui/material'
import { ReactComponent as BranchingIcon } from '../../../../../assets/branching.svg'
import { checkQuestionValidation } from '../../../helpers'
import { notification } from '../../../../../components/Notifications'
import { type Question } from '../../../types'
import { ButtonSize } from '../../../../../components/GenericButton/styles'
import { BRANCHING_TOOLTIP_TITLE } from '../../../constant'
import CustomTooltip from '../../../../../components/CustomTooltip'

interface CreateQuestionCardWrapperProps {
  children: JSX.Element
  questionNumber?: number
  questionData: Question
  section: ISurveySection
  isAdminAddedQuestion?: boolean
}

const CreateQuestionCardWrapper: React.FC<CreateQuestionCardWrapperProps> = ({ children, questionNumber, questionData, section, isAdminAddedQuestion }): JSX.Element => {
  const dispatch = useDispatch()
  const editableQuestion = getEditableQuestion()
  const { questionIndex } = editableQuestion ?? {}

  const handleDelete = (): void => {
    if (questionData?.branchingFilters && questionData?.branchingFilters?.length > 0) {
      notification('This Question contains a Branch section. You cannot delete this section', { variant: 'error' })
      return
    }
    if (editableQuestion?.question) {
      dispatch(deleteQuestionFromSection({ surveySectionId: section.surveySectionId, questionIndex }))
      return
    }
    dispatch(setSelectedQuestion(null))
  }

  const isQuestionValid = checkQuestionValidation(questionData)
  const branchingTooltipTitle = isQuestionValid ? '' : BRANCHING_TOOLTIP_TITLE

  return (
    <StyledCreateQuestionBox>
      <StyledQuestionBoxHeader sx={{ color: grey[700], fontWeight: 500 }} >
        Question {questionNumber}
        <Box display='flex' justifyContent='center' alignItems='center'>
          {!isAdminAddedQuestion &&
            <CustomTooltip title={branchingTooltipTitle}>
              <GenericButton
                buttonSize={ButtonSize.Small}
                disabled={!isQuestionValid}
                onClick={() => dispatch(setBranchModal(true))}
                label='Create Branching Section'
                startIcon={<BranchingIcon opacity={!isQuestionValid ? 0.3 : 1} />}
                style={{ fontSize: '14px', fontWeight: 600, color: blue[950] }} />
            </CustomTooltip>
          }
          <CreateQuestionCardDropDownMenu handleDelete={handleDelete} />
        </Box>
      </StyledQuestionBoxHeader>
      <StyledBoxWrapper >
        {children}
      </StyledBoxWrapper>
    </StyledCreateQuestionBox>
  )
}

export default CreateQuestionCardWrapper
